"use strict";

exports.__esModule = true;
exports.default = void 0;

var _emotion = require("emotion");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _base = _interopRequireDefault(require("../../shared/base"));

var _font = _interopRequireDefault(require("../../shared/font"));

var _utils = require("../../shared/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype.__proto__ = superClass && superClass.prototype;
  subClass.__proto__ = superClass;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Nav = /*#__PURE__*/(0, _reactEmotion.default)('nav', {
  target: "e1oh6sr10"
})(_base.default, ";", _font.default, ";display:flex;position:absolute;width:100%;height:", function (props) {
  return props.height || '60px';
}, ";top:0;left:0;padding:0 15px;z-index:10;transition:all 0.3s ease;&.fixed{position:fixed;background:", function (props) {
  return props.dark ? '#021019' : '#fff';
}, ";box-shadow:", function (props) {
  return props.dark ? '0px 2px 4px 0 rgba(0,0,0,0.3)' : '0px 2px 4px 0 rgba(0,0,0,0.08)';
}, ";}.list{display:inline-flex;flex-grow:1;list-style:none;justify-content:flex-end;flex-direction:row;max-width:600px;li{display:flex;justify-content:center;align-items:center;margin:", function (props) {
  return props.gutter ? "0 0 0 " + props.gutter : '0 0 0 40px';
}, ";}a{text-decoration:none;color:", function (props) {
  return props.dark ? '#eee' : '#383E43';
}, ";transition:all 0.3s ease;font-size:14px;font-weight:", function (props) {
  return props.bold ? '600' : '400';
}, ";text-transform:", function (props) {
  return props.uppercase ? 'uppercase' : 'inherit';
}, ";letter-spacing:0.02rem;padding-top:2px;padding-bottom:2px;border-bottom:2px solid inherit;transition:all 0.3s ease;&:hover,&:focus{color:", function (props) {
  return props.dark ? '#fff' : (0, _utils.shade)('#383E43', -0.2);
}, ";}}li.button a{color:#fff;line-height:15px;}li.active a{border-bottom:2px solid\n\t\t\t\t", function (props) {
  return props.dark ? '#eee' : '#383E43';
}, ";}}.mobile-nav{display:none;}@media all and (max-width:767px){.mobile-nav{display:block;}.list{position:fixed;top:0;width:100%;height:100vh;max-width:400px;right:-400px;color:#424242;margin:0;padding:0;display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:#f3f3f3;transition:all 0.3s ease;overflow-y:auto;li{margin:0;width:100%;padding:12px 0;}&.with-mobile-nav{display:none;}&.mobile-nav{justify-content:flex-start;padding-top:80px;}}&.is-open .list{right:0;li a{color:#424242;}li.button a{color:#fff;}li.active a{border-bottom:2px solid transparent;color:", function (props) {
  return (0, _utils.getProperty)(props, 'primaryColor');
}, ";}}}");
var ToggleMenu = /*#__PURE__*/(0, _reactEmotion.default)('button', {
  target: "e1oh6sr11"
})("display:none;border:0;background-color:transparent;box-shadow:none;outline:none;user-select:none;z-index:1;margin:22px 0;cursor:pointer;@media all and (max-width:767px){display:block;}span{display:block;width:33px;height:4px;margin-bottom:5px;position:relative;background:", function (props) {
  return props.dark ? '#cdcdcd' : '#333';
}, ";border-radius:3px;z-index:1;transform-origin:4px 0px;transition:transform 0.5s cubic-bezier(0.77,0.2,0.05,1),background 0.5s cubic-bezier(0.77,0.2,0.05,1),opacity 0.55s ease;&:first-child{transform-origin:0% 0%;}&:nth-last-child(3){transform-origin:0% 100%;}}&.active span{opacity:1;transform:rotate(-45deg) translate(-2px,-1px);background:#232323;&:nth-last-child(2){opacity:0;transform:rotate(0deg) scale(0.2,0.2);}&:nth-last-child(3){transform:rotate(45deg) translate(-2px,-1px);}}");

var Navbar = /*#__PURE__*/function (_Component) {
  function Navbar() {
    var _temp, _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (_temp = _this = _Component.call.apply(_Component, [this].concat(args)) || this, _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      showMenu: false
    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleScroll", function () {
      var nav = document.getElementById('nav');
      var threshold = _this.props.fixOffset || 0;

      if (window.pageYOffset <= threshold) {
        nav.classList.remove('fixed');
        _this.isFixed = false;
      } else {
        nav.classList.add('fixed');
        _this.isFixed = true;
      }
    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleMenu", function () {
      _this.setState(function (_ref) {
        var showMenu = _ref.showMenu;
        return {
          showMenu: !showMenu
        };
      });
    }), _temp) || _assertThisInitialized(_this);
  }

  var _proto = Navbar.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var enableScroll = this.props.enableScroll;

    if (enableScroll) {
      this.isFixed = false;
      var nav = document.getElementById('nav');

      if (this.props.fixed) {
        nav.classList.add('fixed');
      } else {
        window.addEventListener('scroll', this.handleScroll);
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        fixOffset = _this$props.fixOffset,
        toggleMenu = _this$props.toggleMenu,
        props = _objectWithoutProperties(_this$props, ["children", "className", "fixOffset", "toggleMenu"]);

    var isOpen = this.state.showMenu ? 'is-open' : '';
    var toggleMenuClass = this.state.showMenu ? (0, _reactEmotion.cx)(toggleMenu.className, 'active') : toggleMenu.className;
    return _react.default.createElement(Nav, _extends({
      id: "nav",
      fixOffset: fixOffset
    }, props, {
      className: (className || '') + " " + isOpen + " " + (this.isFixed ? 'fixed' : '')
    }), _react.default.createElement("div", {
      className: (0, _emotion.css)({
        maxWidth: 1400,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '0 auto'
      })
    }, children, this.isNavbarList ? _react.default.createElement(ToggleMenu, {
      className: toggleMenuClass,
      onClick: this.toggleMenu,
      dark: this.props.dark
    }, _react.default.createElement("span", null), _react.default.createElement("span", null), _react.default.createElement("span", null)) : null));
  };

  _createClass(Navbar, [{
    key: "isNavbarList",
    get: function get() {
      var children = this.props.children;

      var isList = _react.default.Children.toArray(children).find(function (child) {
        return child.type === Navbar.List;
      });

      return isList;
    }
  }]);

  _inheritsLoose(Navbar, _Component);

  return Navbar;
}(_react.Component);

_defineProperty(Navbar, "Logo", function (_ref2) {
  var children = _ref2.children;
  return _react.default.createElement(_react.Fragment, null, children);
});

_defineProperty(Navbar, "List", function (_ref3) {
  var children = _ref3.children,
      renderMobileNav = _ref3.renderMobileNav;
  return renderMobileNav ? _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
    className: "list mobile-nav"
  }, renderMobileNav()), _react.default.createElement("ul", {
    className: "list with-mobile-nav"
  }, children)) : _react.default.createElement("ul", {
    className: "list"
  }, children);
});

Navbar.defaultProps = {
  toggleMenu: {},
  enableScroll: true
};
Navbar.propTypes = {
  className: _propTypes.default.string,
  fixed: _propTypes.default.bool,
  enableScroll: _propTypes.default.bool,
  fixOffset: _propTypes.default.number,
  dark: _propTypes.default.bool,
  toggleMenu: _propTypes.default.object,
  children: _propTypes.default.any // eslint-disable-line

};
var _default = Navbar;
exports.default = _default;